import { useState, useEffect } from 'react'

export function usePersistedState(key:string, defaultValue?:any) {
  const [state, setState] = useState(
    () => {
      const value = localStorage.getItem(key);
      if(typeof value === 'string') {
        return JSON.parse(value)
      }
      return defaultValue;
    }
  );
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);
  return [state, setState];
}
